import styled from 'styled-components';

export const Wrapper = styled.div`
    font-weight: 500;
    font-size: 12px;
    line-height: 130%;
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 0.4);
    white-space: nowrap;
`;
